module.exports = __webpack_public_path__ + "static/media/banner-round-vector.a4a42dad.png";